module.exports = __webpack_public_path__ + "static/media/useDiffPan.e2a63c5a.svg";